import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSort(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 11a1 1 0 1 0-2 0v7.132l-1.445-.964a1 1 0 0 0-1.11 1.664L15 21.202l3.555-2.37a1 1 0 1 0-1.11-1.664L16 18.132V11Zm-8 2a1 1 0 1 0 2 0V5.87l1.445.963a1 1 0 1 0 1.11-1.664L9 2.798l-3.555 2.37a1 1 0 0 0 1.11 1.664L8 5.87V13Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
